import { StorageKeysEnum } from '@/enum/storageKeys.enum';

import { useLocalStorage } from '@/hooks/useLocalStorage';

export const useJWT = () => {
  const {
    value: jwt,
    setItem: setJWT,
    removeItem: removeJWT,
  } = useLocalStorage<string>(StorageKeysEnum.jwt);

  return { jwt, setJWT, removeJWT };
};
